
/*
This class exists to have a unified interface for viewing a shapefile,
regardless of it's type. Just kind of pulls everything together.
 */

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Layer_Shapefile = (function(superClass) {
    extend(Layer_Shapefile, superClass);

    function Layer_Shapefile() {
      this.onSlider = bind(this.onSlider, this);
      Layer_Shapefile.__super__.constructor.call(this);
      this.layoutSelector = null;
    }

    Layer_Shapefile.prototype.onSlider = function(ev, ui) {
      var key, ref, results, sub;
      ref = this.activeSubHandlers;
      results = [];
      for (key in ref) {
        sub = ref[key];
        results.push(sub.onSlider(ev, ui));
      }
      return results;
    };

    Layer_Shapefile.prototype.init = function() {
      var sub;
      this.subHandlers = {
        "Point": {
          "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_Point"
        },
        "Polygon": {
          "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_Polygon"
        },
        "GeoJSON": {
          "class": "grower::handlers/data/layers/shapefile/Layer_Shapefile_GeoJSON"
        }
      };
      sub = this.createSubHandler(this.loadLayoutPostOptions.extra_data);
      if (sub) {
        sub.loadLayoutPostOptions = this.loadLayoutPostOptions;
        sub.init();
      }
      return this.layer_object = sub;
    };

    return Layer_Shapefile;

  })(Handler);

}).call(this);
